var _a, _b, _c;
import { css } from '@emotion/react';
import { mediaQuery } from '../helpers';
import { theme } from '../theme';
import { tokens } from '../tokens';
import { panelEnter, panelExit } from './keyframes';
var closeButtonSizeMap = {
    large: tokens.spacing.xsmall,
    medium: '6px',
};
var variantMap = {
    error: {
        color: theme.error.main,
    },
    info: {
        color: theme.info.main,
    },
    success: {
        color: theme.success.main,
    },
    upgrade: {
        color: theme.upgrade.main,
    },
    warning: {
        color: theme.warning.main,
    },
};
var panelStaticStyle = css((_a = {
        backgroundColor: theme.background.contrast,
        border: "".concat(tokens.borderWidth.thin, " solid ").concat(theme.border.strong),
        borderRadius: tokens.borderRadius.medium,
        boxShadow: theme.boxShadow.thick,
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '100%',
        maxWidth: '600px',
        minHeight: '180px',
        minWidth: '100%',
        opacity: 0,
        outline: 0,
        pointerEvents: 'all',
        position: 'absolute',
        transform: 'translateY(12px)',
        zIndex: tokens.zIndex.modal
    },
    _a[mediaQuery.aboveSmall] = {
        minWidth: '400px',
    },
    _a));
export function panelStyle(_a) {
    var alignCenter = _a.alignCenter, isPositioned = _a.isPositioned, isVisible = _a.isVisible, x = _a.x, y = _a.y;
    return [
        panelStaticStyle,
        css({
            animation: "".concat(isVisible ? panelEnter : panelExit, " 200ms cubic-bezier(0.2, 0.8, 0.6, 1) forwards"),
        }),
        alignCenter &&
            css({
                textAlign: 'center',
            }),
        isPositioned
            ? css({
                left: x !== null && x !== void 0 ? x : 0,
                top: y !== null && y !== void 0 ? y : 0,
                width: 'max-content',
            })
            : css({
                inset: 'unset',
            }),
    ];
}
var closeButtonStaticStyle = css({
    position: 'absolute',
    zIndex: tokens.zIndex.default,
});
export function closeButtonStyle(_a) {
    var hasDecorativeHeader = _a.hasDecorativeHeader, size = _a.size;
    var spacing = closeButtonSizeMap[size];
    return [
        closeButtonStaticStyle,
        css({
            color: hasDecorativeHeader ? theme.navy.textOnColor : theme.text.main,
            right: spacing,
            top: spacing,
        }),
    ];
}
// Required to position shadow scroll indicators at the top or bottom
export var bodyWrapperStaticStyle = css({
    display: 'flex',
    flexGrow: 1,
    overflow: 'hidden',
    position: 'relative',
});
var bodyShadowsStaticStyle = css({
    inset: 0,
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: tokens.zIndex.default,
});
export function bodyShadowsStyle(_a) {
    var isShadowBottomVisible = _a.isShadowBottomVisible, isShadowTopVisible = _a.isShadowTopVisible;
    return [
        bodyShadowsStaticStyle,
        css({
            boxShadow: [
                isShadowTopVisible &&
                    "inset 0 12px 12px -12px ".concat(theme.transparentGrey.main),
                isShadowBottomVisible &&
                    "inset 0 -12px 12px -12px ".concat(theme.transparentGrey.main),
            ].join(','),
        }),
    ];
}
export var bodyStaticStyle = css({
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingBottom: tokens.spacing.small,
    paddingLeft: tokens.spacing.medium,
    paddingRight: tokens.spacing.medium,
    paddingTop: 0,
    width: '100%',
});
var avatarStaticStyle = css({
    alignItems: 'center',
    backgroundColor: theme.background.contrast,
    borderRadius: tokens.borderRadius.circle,
    boxShadow: theme.boxShadow.thick,
    display: 'flex',
    height: tokens.sizing.large,
    justifyContent: 'center',
    position: 'relative',
    top: '50%',
    width: tokens.sizing.large,
});
export function avatarStyle(_a) {
    var variant = _a.variant;
    return [
        avatarStaticStyle,
        css({
            color: variantMap[variant].color,
        }),
    ];
}
var decorativeHeaderStaticStyle = css({
    backgroundColor: theme.navy.lighter,
    borderTopLeftRadius: tokens.borderRadius.medium,
    borderTopRightRadius: tokens.borderRadius.medium,
    display: 'flex',
    height: '52px',
    justifyContent: 'center',
});
export function decorativeHeaderStyle(_a) {
    var variant = _a.variant;
    return [
        decorativeHeaderStaticStyle,
        css({
            borderBottom: "".concat(tokens.borderRadius.medium, " solid ").concat(variantMap[variant].color),
        }),
    ];
}
var headerStaticStyle = css({
    flexShrink: 0,
    margin: 0,
    padding: "".concat(tokens.spacing.medium, " 48px ").concat(tokens.spacing.medium),
});
export function headerStyle(_a) {
    var alignCenter = _a.alignCenter;
    return [
        headerStaticStyle,
        css({
            paddingLeft: alignCenter ? '48px' : tokens.spacing.medium,
        }),
    ];
}
var footerStaticStyle = css((_b = {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        flexShrink: 0,
        flexWrap: 'wrap',
        gap: tokens.spacing.small,
        padding: tokens.spacing.medium
    },
    _b[mediaQuery.aboveSmall] = {
        flexDirection: 'row',
    },
    _b));
export function footerStyle(_a) {
    var alignCenter = _a.alignCenter;
    return [
        footerStaticStyle,
        css({
            justifyContent: alignCenter ? 'center' : 'end',
        }),
    ];
}
export var buttonStaticStyle = css((_c = {
        flexShrink: 1,
        width: '100%'
    },
    _c[mediaQuery.aboveSmall] = {
        width: 'auto',
    },
    _c));
